const EVENTS = [
  {
    title: "Protein Box at Doctor’s Conference",
    location: "Nagpur",
    desc: "Protein Box had a long standing association with Doctors with more than 100+ Doctors having taken Meals.",
    img: "/images/events/doctors-meet.jpg"
  },
  {
    title: "IFFI 2022",
    location: "Panjim, Goa",
    desc: "Protein Box serving healthy meals at International Film Festival of India (IFFI) 2022.",
    img: "/images/events/iffi.jpg"
  },
  {
    title: "T-Hub",
    location: "Hyderabad",
    desc: "Protein Box graduated from T-Hub, Hyderabad, Lab32 Cohort 10",
    img: "/images/events/t-hub.jpg"
  },
  {
    title: "Traffic Rewards",
    location: "Nagpur",
    desc: "Protein Box was chosen amongst the 100 selected partners for the Traffic Rewards Program",
    img: "/images/events/traffic-rewards.jpg"
  },
]

export default EVENTS;